export const darkTheme = {
    bg: "#0B1121",
    bgLight: "#111827",
    bgGlass: "rgba(17, 24, 39, 0.8)",
    primary: "#2563EB",
    primaryGradient: "#2563EB", // Solid blue, no gradient
    secondary: "#38bdf8",
    accent: "#3b82f6",
    text_primary: "#f8fafc",
    text_secondary: "#94a3b8",
    text_muted: "#64748b",
    card: "#1e293b",
    card_light: '#334155',
    cardGlass: "rgba(30, 41, 59, 0.6)",
    border: "rgba(37, 99, 235, 0.2)",
    borderHover: "rgba(37, 99, 235, 0.5)",
    button: "#2563EB",
    white: "#FFFFFF",
    black: "#000000",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    shadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
    shadowGlow: "0 0 40px rgba(37, 99, 235, 0.3)",
}

export const lightTheme = {
    bg: "#f0f9ff",
    bgLight: "#ffffff",
    bgGlass: "rgba(255, 255, 255, 0.8)",
    primary: "#2563EB",
    primaryGradient: "#2563EB", // Solid blue, no gradient
    secondary: "#0284c7",
    accent: "#0ea5e9",
    text_primary: "#0f172a",
    text_secondary: "#334155",
    text_muted: "#64748b",
    card: "#ffffff",
    card_light: '#f8fafc',
    cardGlass: "rgba(255, 255, 255, 0.6)",
    border: "rgba(37, 99, 235, 0.2)",
    borderHover: "rgba(37, 99, 235, 0.5)",
    button: "#2563EB",
    white: "#FFFFFF",
    black: "#000000",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    shadow: "0 25px 50px -12px rgba(0, 0, 0, 0.1)",
    shadowGlow: "0 0 40px rgba(37, 99, 235, 0.2)",
}
